/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 17:28:48
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-25 14:22:45
 */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { send } from "../../app/appSlice";
import { AppThunkApi, RootState } from "../../app/store";
import { Account } from "../../models/account";
import { firstPage, Page } from "../../models/page";
import { AccountStationBody, AccountStationChange, AccountStationDetail, AccountStationPage, AccountStationParams, AccountStationSubmit } from "../../services/AccountStation";
// import { api, sendAsync } from "../../app/appSlice";
// import { RootState, RootThunk, RootThunkApi } from "../../app/appSlice";

interface accountState {
    AccountData: Page<Account>,
    AccountId: 0,
    AccountDetail: any,

}

const initialState: accountState = {
    AccountData: firstPage(),
    AccountId: 0,
    AccountDetail: {}
};

export const getAccountStationAsync = createAsyncThunk<
    void,
    AccountStationParams,
    AppThunkApi
>("AccountStation/page", async (params, api) => {
    return send(AccountStationPage(params), api)
})

export const getAccountStationDetailAsync = createAsyncThunk<
    void,
    number,
    AppThunkApi
>("AccountStation/Detail", async (userId, api) => {
    return send(AccountStationDetail(userId), api)
})

export const AccountSlice = createSlice({
    name: "AccountStation",
    initialState,
    reducers: {
        setAccountData(state, action) {
            state.AccountData = action.payload;
        },

        setAccountId(state, action) {
            state.AccountId = action.payload;
        },
        setAccountDetail(state, action) {
            state.AccountDetail = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAccountStationAsync.fulfilled, (state, action: any) => {
            state.AccountData = action.payload;
        });
        builder.addCase(getAccountStationDetailAsync.fulfilled, (state, action: any) => {
            state.AccountDetail = action.payload
        })
    }
});

export const { setAccountData,  setAccountId, setAccountDetail } =
    AccountSlice.actions;

export const AccountStationSubmitAsync = createAsyncThunk<
    void,
    AccountStationBody,
    AppThunkApi
>("AccountStation/submit", async (body, api) => {
    return send(AccountStationSubmit(body), api)
})

export const AccountStationChangeAsync = createAsyncThunk<
    void,
    number,
    AppThunkApi
>("AccountStation/change", async (userId, api) => {
    return send(AccountStationChange(userId), api)
})

export const selectAccountData = (state: RootState) => state.accountStation.AccountData

export const selectAccountId = (state: RootState) => state.accountStation.AccountId

export const selectAccountDetail = (state: RootState) => state.accountStation.AccountDetail

export default AccountSlice.reducer;